import { HeadersFunction, MetaFunction } from "react-router";
import termsConditionData from "~/data/policy/terms-condition.json";
import { useFontStyle } from "~/hook/useFontStyle";
import { getPageMeta } from "~/lib/helperFuncation/metaHelper";
import { cn } from "~/lib/utils";
import { CACHED_PAGE, FALLBACK_IMAGE_URL, LANG } from "~/utils/constant";
import { computeEtagFromData } from "~/utils/helper-funcations";
import { metaService } from "~/utils/metaService";

export const meta: MetaFunction = ({ location, params }) => {
  const pathname = location?.pathname || "/";
  const lang = params.lang || "en";

  const meta = getPageMeta("termsAndConditions", lang);

  return metaService({
    title: meta.metaTitle,
    description: meta.metaDescription,
    ogTitle: meta.ogTitle,
    ogDescription: meta.ogDescription,
    ogUrl: pathname,
    ogImg: meta.ogImage || FALLBACK_IMAGE_URL,
    ogWidth: meta.ogImageWidth || "1200",
    ogHeight: meta.ogImageHeight || "630",
    canonicalLink: pathname,
    hreflangs: termsConditionData.hreflangs.map((lang) => ({
      ...lang,
      href: `${lang.href}${pathname}`,
    })),
  });
};

export const loader = ({ params, request }: { params: { lang: string }; request: Request }) => {
  const lang = params.lang || LANG.english;

  const DATA = {
    title: lang === LANG.english ? "Terms & Conditions" : "નિયમ અને શરતો",
  };

  const etag = computeEtagFromData(DATA);
  const ifNoneMatch = request.headers.get("If-None-Match");
  if (ifNoneMatch === etag) {
    return new Response(null, {
      status: 304,
      headers: {
        Etag: etag,
      },
    });
  }
  return Response.json(DATA, {
    headers: { ...CACHED_PAGE.POLICY.HEADERS, ETag: etag },
  });
};

export const headers: HeadersFunction = ({ loaderHeaders }) => loaderHeaders;

function TermsCondition() {
  const { normalInter, medium } = useFontStyle();
  return (
    <div className="space-y-4 p-4 max-w-4xl mx-auto">
      {termsConditionData.content.sections.map((section, index) => (
        <div key={index}>
          <h2 className={cn("h4_heading text-textColor mb-2", medium)}>
            {section.number}. {section.title}
          </h2>
          {section.content.map((paragraph, pIndex) => (
            <p className={cn("text-textSecondaryColor body_text_m", normalInter)} key={pIndex} dangerouslySetInnerHTML={{ __html: paragraph }} />
          ))}
        </div>
      ))}
    </div>
  );
}

export default TermsCondition;
